module.exports = __webpack_public_path__ + "static/media/Martin Van Buren - 1836.1d0b4ace.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Martin Van Buren - 1836.jpg
// module id = 531
// module chunks = 0